import styled from 'styled-components';

import { PADDING_CONTENT_PAGE, FONT_SIZE_INFO_WRAPPER_TITLE, COLOR_ICON_INFO_WRAPPER } from '../../../globals';


export const StyledInfoWrapper = styled.div`
  padding: 8px ${PADDING_CONTENT_PAGE}px 12px ${PADDING_CONTENT_PAGE}px;

  .info-wrapper-table {
    
  }

  tr {
    vertical-align: top;
  }

  .info-wrapper-icon {
    vertical-align: top;
    padding: 0px 10px 0px 5px;
    font-size: 1.5em;
    color: ${COLOR_ICON_INFO_WRAPPER};
  }

  .info-wrapper-title {
    font-size: ${FONT_SIZE_INFO_WRAPPER_TITLE}em;
  }

`;
